import { getValidStoredToken, handleUnauthorizedApiResponse } from "./authSession";

export async function getLifeSuiteSession(expectedSession) {
  const token = getValidStoredToken({ notifyOnExpiration: true });
  if (!token || token !== expectedSession) throw new Error("Your account changed. Reopen support to continue.");
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || "http://localhost:5005"}/api/life-suite/widget-session`, {
    method: "POST", cache: "no-store", credentials: "omit",
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: "{}",
    signal: AbortSignal.timeout(15000),
  });
  handleUnauthorizedApiResponse(response, undefined, token);
  if (!response.ok) throw new Error(response.status === 429 ? "Please wait before reconnecting to support." : "Support is temporarily unavailable. Please try again later.");
  const data = await response.json();
  if (getValidStoredToken() !== expectedSession) throw new Error("Your account changed. Reopen support to continue.");
  const base = new URL(data.baseUrl);
  const local = process.env.NODE_ENV !== "production" && base.protocol === "http:" && ["localhost", "127.0.0.1"].includes(base.hostname);
  if ((base.protocol !== "https:" && !local) || base.origin !== data.baseUrl || base.username || base.password
    || typeof data.token !== "string" || !/^v1\.[\w-]+\.[\w-]+$/.test(data.token) || data.token.length > 4096
    || !Number.isFinite(Date.parse(data.expiresAt)) || Date.parse(data.expiresAt) <= Date.now()) {
    throw new Error("Support session is unavailable. Please try again.");
  }
  return data;
}
